<template>
  <v-container
    fluid
    class="pt-2 grey lighten-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
  >
    <v-layout column class="answer-list-container">
      <v-card v-for="group in orderedGroups" :key="group.id" class="mb-2">
        <v-card-title class="headline">{{ group.name }}</v-card-title>
        <answers :questions="group.questions"></answers>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import Answers from './Answers';

export default {
  components: { Answers },
  name: 'groups',
  props: ['journey'],
  computed: {
    ...mapGetters(['Questions']),
    orderedGroups: function() {
      return _.isUndefined(this.journey) ? {} : _.orderBy(this.journey.question_groups, 'number');
    }
  },
  methods: {
    ...mapActions(['getQuestions'])
  },
  mounted() {
    this.getQuestions();
  }
};
</script>

<style lang="scss" scoped>
.answer-list-container {
  height: calc(100vh - 150px);
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
